module.exports = __webpack_public_path__ + "static/media/x-logo-black.c019bd43.png";